import { getCourse } from '$lib/api/courses';
import type { PageLoad } from './$types';

export const load: PageLoad = ({parent, params, fetch }) => {
  async function loadCourse() {
    const parentData = await parent();
    const classInfo = await parentData.classPromise;
    return await getCourse(classInfo.courseId, fetch);
  }
  return {
    coursePromise: loadCourse(),
  };
};
